import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { dropdownItem, selectContent, selectTrigger } from "@/lib/dropdownMotion";

const EMPTY = "__rp_empty__";

/**
 * Animated select — drop-in replacement for native <select> with app styling.
 */
export function RpSelect({
  value,
  onValueChange,
  placeholder,
  className,
  children,
  options,
  disabled,
  allowEmpty = false,
  testId,
}) {
  const isEmpty = value === "" || value == null;
  const radixValue = allowEmpty && isEmpty ? EMPTY : isEmpty ? undefined : String(value);

  const handleChange = (v) => {
    onValueChange?.(v === EMPTY ? "" : v);
  };

  return (
    <Select value={radixValue} onValueChange={handleChange} disabled={disabled}>
      <SelectTrigger data-testid={testId} className={cn(selectTrigger, className)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={selectContent} position="popper">
        {allowEmpty && (
          <SelectItem className={dropdownItem} value={EMPTY}>
            {placeholder || "—"}
          </SelectItem>
        )}
        {options
          ? options.map((opt) => (
              <SelectItem
                key={String(opt.value)}
                className={dropdownItem}
                value={String(opt.value)}
              >
                {opt.label}
              </SelectItem>
            ))
          : children}
      </SelectContent>
    </Select>
  );
}

export function RpSelectItem({ value, children, className }) {
  return (
    <SelectItem className={cn(dropdownItem, className)} value={String(value)}>
      {children}
    </SelectItem>
  );
}
